import VueCookies from 'vue-cookies';

const cookieUrl = process.env.NODE_ENV == 'development' ? 'localhost' : window.location.host
const cookieSecurity = process.env.NODE_ENV == 'development' ? false : true

const affiliateStorageNamespace = process.env.VUE_APP_AFFILIATE_COOKIE_TOKEN;
const affiliateTime = process.env.VUE_APP_AFFILIATE_COOKIE_TIME;

const affiliate = VueCookies.get(affiliateStorageNamespace)

const state = {
    affiliate: affiliate || null
}
const getters = {
    getAffiliate: (state) => state.affiliate
}
const mutations = {
    AFFILIATE_TOKEN(state, payLoad) {
        state.affiliate = payLoad;
        VueCookies.set(affiliateStorageNamespace, payLoad, affiliateTime, null, cookieUrl, cookieSecurity);
    }
}
const actions = {
    setAffiliate: ({ commit }, payLoad) => {
        commit('AFFILIATE_TOKEN', payLoad)
    },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}